
export const AddIcon = (props: { size?: number}) => {
    return (
        <svg width={props.size || 32} height={props.size || 32} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><title>Agregar</title><path d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z" fill="none" stroke="#33ACE1"  strokeMiterlimit="10" strokeWidth="32"/><path fill="none" stroke="#33ACE1" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M256 176v160M336 256H176"/></svg>
    );
}